import { render, staticRenderFns } from "./TraineeCalendar.vue?vue&type=template&id=65fb01de&scoped=true&lang=pug&"
import script from "./TraineeCalendar.vue?vue&type=script&lang=js&"
export * from "./TraineeCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TraineeCalendar.vue?vue&type=style&index=0&id=65fb01de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb01de",
  null
  
)

export default component.exports